import api from './api';

/** Tranche B4 (#489): Herkunft und Freigabe eines Kurses. */

export type CourseOrigin = 'manual' | 'generated' | 'assisted' | 'variant';

export interface ProvenanceSummary {
    courseId: number;
    origin: CourseOrigin;
    signOffRequired: boolean;
    generation: {
        jobType: string | null;
        jobId: number | null;
        generatedBy: number | null;
        generatedByName: string | null;
        generatedAt: string | null;
        promptVersion: string | null;
        engine: string | null;
        models: string[];
        sourceMaterialHash: string | null;
        sourceMaterialChars: number;
        derivedFromCourseId: number | null;
    } | null;
    quality: { reportId: number; score: number | null; completedAt: string | null } | null;
    signOff: { by: number | null; byName: string | null; at: string | null; note: string | null; changedSince: boolean } | null;
    contentFingerprint: string;
}

export const provenanceService = {
    async get(courseId: number): Promise<ProvenanceSummary> {
        const { data } = await api.get(`/courses/${courseId}/provenance`);
        return data;
    },
    async signOff(courseId: number, note?: string): Promise<ProvenanceSummary> {
        const { data } = await api.post(`/courses/${courseId}/sign-off`, note ? { note } : {});
        return data;
    },
    async withdraw(courseId: number): Promise<ProvenanceSummary> {
        const { data } = await api.delete(`/courses/${courseId}/sign-off`);
        return data;
    },
};

export default provenanceService;
